export const LogisticsActionKeys = {
  ADD_ITEMS_TO_CONTAINER: 'ADD_ITEMS_TO_CONTAINER',
  ADD_ITEMS_TO_LOAD: 'ADD_ITEMS_TO_LOAD',
  ADD_SHIPMENT_CONTAINER: 'ADD_SHIPMENT_CONTAINER',
  ADVANCE_LOAD_STATE: 'ADVANCE_LOAD_STATE',
  CREATE_LOAD: 'CREATE_LOAD',
  DELETE_LOAD: 'DELETE_LOAD',
  DELETE_LOGISTICS_USER: 'DELETE_LOGISTICS_USER',
  DELETE_SHIPMENT: 'DELETE_SHIPMENT',
  DELETE_SHIPMENT_CONTAINER: 'DELETE_SHIPMENT_CONTAINER',
  DELETE_SHIPMENT_ITEM: 'DELETE_SHIPMENT_ITEM',
  DELETE_SHIPMENT_KIT: 'DELETE_SHIPMENT_KIT',
  DELETE_WAREHOUSE_GROUP: 'DELETE_WAREHOUSE_GROUP',
  FETCH_CARRIER: 'FETCH_CARRIER',
  FETCH_CARRIER_LOADS: 'FETCH_CARRIER_LOADS',
  FETCH_CARRIERS: 'FETCH_CARRIERS',
  FETCH_LOAD: 'FETCH_LOAD',
  FETCH_LOAD_CALENDAR: 'FETCH_LOAD_CALENDAR',
  FETCH_LOAD_EVENTS: 'FETCH_LOAD_EVENTS',
  FETCH_LOAD_ROUTE: 'FETCH_LOAD_ROUTE',
  FETCH_LOGISTICS_DAILY_SUMMARIES: 'FETCH_LOGISTICS_DAILY_SUMMARIES',
  FETCH_LOGISTICS_USERS: 'FETCH_LOGISTICS_USERS',
  FETCH_SHIPMENT: 'FETCH_SHIPMENT',
  FETCH_SHIPMENT_LIST: 'FETCH_SHIPMENT_LIST',
  FETCH_SHIPMENT_LIST_FULFILLED: 'FETCH_SHIPMENT_LIST_FULFILLED',
  FETCH_SHIPMENT_LIST_REJECTED: 'FETCH_SHIPMENT_LIST_REJECTED',
  FETCH_SHIPMENT_REJECTED: 'FETCH_SHIPMENT_REJECTED',
  MOVE_SHIPMENT_ITEMS: 'MOVE_SHIPMENT_ITEMS',
  REMOVE_LOAD: 'REMOVE_LOAD',
  REMOVE_LOAD_ROUTE: 'REMOVE_LOAD_ROUTE',
  REMOVE_LOGISTICS_USER: 'REMOVE_LOGISTICS_USER',
  REMOVE_SHIPMENT: 'REMOVE_SHIPMENT',
  REMOVE_SHIPMENT_CONTAINER: 'REMOVE_SHIPMENT_CONTAINER',
  REMOVE_SHIPMENT_ITEMS: 'REMOVE_SHIPMENT_ITEMS',
  REMOVE_WAREHOUSE_GROUP: 'REMOVE_WAREHOUSE_GROUP',
  SET_CARRIERS: 'SET_CARRIERS',
  SET_LOAD: 'SET_LOAD',
  SET_LOAD_EVENTS: 'SET_LOAD_EVENTS',
  SET_LOAD_FINAL_DESTINATION: 'SET_LOAD_FINAL_DESTINATION',
  SET_LOAD_PARTIAL: 'SET_LOAD_PARTIAL',
  SET_LOAD_ROUTE: 'SET_LOAD_ROUTE',
  SET_LOAD_VALUE: 'SET_LOAD_VALUE',
  SET_LOGISTICS_DAILY_SUMMARIES: 'SET_LOGISTICS_DAILY_SUMMARIES',
  SET_LOGISTICS_FILTERS: 'SET_LOGISTICS_FILTERS',
  SET_LOGISTICS_USERS: 'SET_LOGISTICS_USERS',
  SET_MIN_LOADS: 'SET_MIN_LOADS',
  SET_SHIPMENT: 'SET_SHIPMENT',
  SET_SHIPMENT_CONTAINER: 'SET_SHIPMENT_CONTAINER',
  SET_SHIPMENT_ITEMS: 'SET_SHIPMENT_ITEMS',
  SET_SHIPMENT_LOADSTATE: 'SET_SHIPMENT_LOADSTATE',
  SET_SHIPMENT_STOP_NUMBERS: 'SET_SHIPMENT_STOP_NUMBERS',
  SPLIT_SHIPMENT_ITEM: 'SPLIT_SHIPMENT_ITEM',
  TOGGLE_SHIPMENT_LIST_LOADING: 'TOGGLE_SHIPMENT_LIST_LOADING',
  UPDATE_LOAD: 'UPDATE_LOAD',
  UPDATE_LOAD_DEPARTURE_DATE: 'UPDATE_LOAD_DEPARTURE_DATE',
  UPDATE_LOAD_FEES: 'UPDATE_LOAD_FEES',
  UPDATE_LOAD_ROUTE: 'UPDATE_LOAD_ROUTE',
  UPDATE_LOGISTICS_USER: 'UPDATE_LOGISTICS_USER',
  UPDATE_SHIPMENT: 'UPDATE_SHIPMENT',
  UPDATE_SHIPMENT_CONTAINER: 'UPDATE_SHIPMENT_CONTAINER',
  UPDATE_WAREHOUSE: 'UPDATE_WAREHOUSE',
  UPDATE_WAREHOUSE_GROUP: 'UPDATE_WAREHOUSE_GROUP'
} as const;
